import React, { FC, ReactNode } from 'react';

import { ChevronDownIcon } from 'src/shared/components/icons';
import './CollapsibleLabel.styles.scss';

interface Props {
  label: ReactNode;
  in: boolean;
  onClick: () => void;
  className?: string;
}

export const CollapsibleLabel: FC<Props> = ({ label, in: collapsible, onClick, className = '' }) => {
  const openClass = collapsible ? 'open' : '';

  return (
    <div
      className={`d-flex align-items-center justify-content-between mb-3 cursor-pointer collapsible-label ${openClass} ${className}`}
      onClick={onClick}
    >
      <div className="large fw-500 mb-0">{label}</div>
      <ChevronDownIcon className="collapsible-chevron-icon" size={20} />
    </div>
  );
};
